import React from "react";
import { default as MUIBadge } from "@mui/material/Badge";
import styled from "styled-components";

const StyledMUIBadge = styled(MUIBadge)``;

export const Badge = (props) => {
  return <StyledMUIBadge {...props} />;
};
